/* Meubléa — animations au défilement, compteurs et parallaxe */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealTargets(root) {
    var groups = [
      ['.mb-stats > *, .mb-g4 > *, .mb-g3 > *, .mb-ways > *, .mb-reass > *, .mb-why > *', 'up', true],
      ['.mb-bento > *, .mb-split > *, .mb-close > *', 'up', true],
      ['.mb-card.mb-pad, .mb-guide, .mb-help, .mb-quoteband, .mb-news', 'up', false],
      ['.mb-head', 'fade', false]
    ];
    groups.forEach(function (g) {
      root.querySelectorAll(g[0]).forEach(function (el) {
        if (el.hasAttribute('data-mb-reveal') || el.closest('.mb-hero, .mb-phero')) return;
        el.setAttribute('data-mb-reveal', g[1]);
        if (g[2] && el.parentElement) {
          var i = Array.prototype.indexOf.call(el.parentElement.children, el);
          el.style.setProperty('--mb-delay', Math.min(i, 7) * 90 + 'ms');
        }
      });
    });
  }

  function countUp(el) {
    if (el.dataset.mbCounted) return;
    el.dataset.mbCounted = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/^(\d{1,4})(.*)$/);
    if (!m || reduce) return;
    var end = parseInt(m[1], 10), suffix = m[2];
    if (end === 0) return;
    var start = end >= 1000 ? end - 30 : 0, t0 = null, dur = 1400;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(start + (end - start) * e) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function countIn(target) {
    target.querySelectorAll('.mb-stat__n').forEach(countUp);
    if (target.classList.contains('mb-stat')) {
      var n = target.querySelector('.mb-stat__n');
      if (n) countUp(n);
    }
  }

  function observe(root) {
    var els = root.querySelectorAll('[data-mb-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        countIn(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function images(root) {
    root.querySelectorAll('.mb img.mb-img').forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  function parallax() {
    if (reduce || window.innerWidth < 750) return;
    var media = document.querySelectorAll('.mb-hero__media, .mb-phero .mb-hero__media');
    if (!media.length) return;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      media.forEach(function (m) {
        var r = m.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        m.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function init(root) {
    root = root || document;
    revealTargets(root);
    observe(root);
    images(root);
  }

  document.documentElement.classList.add('mb-js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); parallax(); });
  } else { init(); parallax(); }

  /* Éditeur de thème : réappliquer quand une section est rechargée */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Sécurité : tout afficher si quelque chose bloque */
  setTimeout(function () {
    document.querySelectorAll('[data-mb-reveal]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('is-in'); countIn(el); }
    });
  }, 2500);
})();
